module.exports = __webpack_public_path__ + "img/edit.0fc3e89e.svg";